import { useExperimentSetter, useHandleAuthJWT } from 'helpers/hooks';
import React from 'react';
import { Outlet } from 'react-router-dom';

// In this components we can handle all the Route hooks can be handled and entry of any page
export default () => {
  useExperimentSetter();
  useHandleAuthJWT();
  return <Outlet />;
};
